module.exports = __webpack_public_path__ + "media/images/category_icons/cuisine-2e45c2a7ae23167ea941037c8e60e8e7.svg";